







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Api from "@/api";

import Error404 from "@/components/Common/Error404.vue";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import luxonPlugin from "@fullcalendar/luxon";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";
import {
  IEvent,
  IFacility,
  IVenue,
  IBooking,
  IVenueBooking
} from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    DatePicker,
    Error404
  }
})
export default class Calendar extends Vue {
  private componentKey = 0;
  private noDataExist = false;
  private facilities: Array<IFacility> = [];
  private selectedVenue: IVenue | null = null;
  private selectedVenueId: number | "default" | null = null;
  private bookings: Array<IBooking> = [];
  private selectedDate = new Date();
  private dateFormat = "DD.MM.YYYY";
  private CalendarApi: any | null = null;
  private calendarOptions: any = {
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      interactionPlugin, // needed for dateClick
      luxonPlugin
    ],
    headerToolbar: {
      left: "prev next today",
      center: "title",
      right: "dayGridMonth timeGridWeek timeGridDay"
    },
    views: {
      timeGrid: {
        titleFormat: "{{d.} LLLL} yyyy"
      }
    },
    height: "auto",
    allDaySlot: false,
    firstDay: 1,
    dayHeaderFormat: "EEE d.M",
    datesSet: this.handleChangeDate,
    slotMinTime: "07:00:00",
    slotMaxTime: "21:00:00",
    slotLabelFormat: "HH:mm",
    eventTimeFormat: "HH:mm",
    slotDuration: "00:30:00",
    initialView: "timeGridWeek",
    initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
    editable: true,
    droppable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    select: this.handleDateSelect,
    eventClick: this.handleEventClick,
    eventsSet: this.handleEvents,
    eventDragStart: this.handleEventDragStart,
    eventDrop: this.handleEventDrop,
    eventReceive: this.handleEventDrop
    /* you can update a remote database when these fire:
    eventAdd:
    eventChange:
    eventRemove:
    */
  };
  private currentEvents: Array<IEvent> = [];
  private starts_at: Date | string | null = null;
  private ends_at: Date | string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedVenueId =
        vm.$route.params.id === "default"
          ? "default"
          : parseInt(vm.$route.params.id, 10);
      vm.getFacilities(() => {
        vm.getVenue(() => {
          vm.getBookings();
        });
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.selectedVenueId = to.params.id;
    this.getFacilities(() => {
      this.getVenue(() => {
        this.getBookings();
      });
    });
    next();
  }

  private mounted(): void {
    document
      .getElementsByClassName("fc-toolbar-chunk")[0]
      .prepend(document.getElementById("selected-date") as any);

    this.CalendarApi = (this.$refs.calendar as any).$options.calendar;
  }

  private getFacilities(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getVenue(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenue = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      });
  }

  private getBookings(successCallback?: any): void {
    this.bookings = [];
    const endpoint = this.$partnerEndpoint("bookings");

    Api()
      .get(endpoint, {
        params: {
          from_start_date:
            this.starts_at &&
            (this.starts_at as Date).toISOString().replace(/T.*$/, ""),
          until_start_date:
            this.ends_at &&
            (this.ends_at as Date).toISOString().replace(/T.*$/, ""),
          // start_date: this.selectedDate.toISOString().replace(/T.*$/, ""),
          venue_id: this.selectedVenueId,
          page: 1,
          per_page: 1000
        }
      })
      .then((response: AxiosResponse) => {
        this.bookings = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      });
  }

  private handleDateSelect(selectInfo: any): void {
    this.$router.push({
      name: "NewBookingVenue",
      query: {
        from_date_time: selectInfo.startStr,
        until_date_time: selectInfo.endStr,
        venue_ids: [this.selectedVenueId as string]
      }
    });
  }

  private handleEventClick(clickInfo: any): void {
    this.$router.push({
      name: "BookingVenueDetails",
      params: { booking_id: clickInfo.event._def.extendedProps.source.id }
    });
  }

  private handleEvents(events: Array<IEvent>): void {
    this.currentEvents = events;
  }

  private handleEventDragStart(): void {
    this.CalendarApi.setOption("snapDuration", "00:05:00");
  }

  private handleEventDrop(): void {
    this.CalendarApi.setOption("snapDuration", "00:30:00");
  }

  private handleChangeDate(dateInfo: any): void {
    this.selectedDate = dateInfo.start;
    this.starts_at = dateInfo.start;
    this.ends_at = dateInfo.end;
    if (this.selectedVenueId) {
      this.getBookings();
    }
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  get venueName(): string {
    return (this.selectedVenue !== null && this.selectedVenue.name) || "";
  }

  @Watch("selectedVenueId")
  selectedVenueIdChanged(selectedVenueId: number): void {
    this.$router.push({
      name: "VenueCalendar",
      params: { id: `${selectedVenueId}` }
    });
  }

  @Watch("selectedDate")
  selectedDateChanged(newDate: Date): void {
    newDate && this.CalendarApi.gotoDate(newDate);
  }

  @Watch("bookings")
  bookingsChanged(newState: Array<IBooking>): void {
    let events: Array<any> = [];
    newState.forEach((booking: IBooking) => {
      if (booking.venue_bookings) {
        const selectedVenueBooking = booking.venue_bookings.find(
          (venueBooking: IVenueBooking) =>
            venueBooking.venue?.id === parseInt(`${this.selectedVenueId}`, 10)
        );
        events.push({
          id: selectedVenueBooking?.id,
          start: selectedVenueBooking?.starts_at,
          end: selectedVenueBooking?.ends_at,
          title: selectedVenueBooking?.venue?.name,
          source: booking
        });
      }
    });
    this.currentEvents = events;
    this.CalendarApi.setOption("events", events);
  }
}
